<template>
  <div
    v-resize="onResize"
    class="fill-height"
    :style="`overflow: hidden; height: ${windowSize.y - 64}px`"
  >
    <v-dialog v-model="dialogShowCurriculum" fullscreen scrollable>
      <v-card v-if="selectPostulant" tile elevation="0">
        <v-card-title class="display-1">
          <div>
            <span class="mr-4 font-weight-light">Hoja de vida</span>
            <span v-if="selectPostulant.documentos">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <a
                    style="text-decoration: none"
                    :href="selectPostulant.documentos.documento"
                    :download="selectPostulant.documentos.nombre"
                    target="_blank"
                  >
                    <v-btn v-on="on" class="ml-2" icon>
                      <v-icon>mdi-file-download</v-icon>
                    </v-btn>
                  </a>
                </template>
                <span>Descargar certificados</span>
              </v-tooltip>
            </span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  class="ml-2"
                  icon
                  target="_blank"
                  :to="{ name: 'company app notices print curriculum applicant', params: { postulante: selectPostulant.usuario } }"
                >
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
              </template>
              <span>Imprimir hoja de vida</span>
            </v-tooltip>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="dialogShowCurriculum = false; showCartaPostulacion = ''; showPreguntas = ''"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <Curriculum ref="print-curriculum" v-if="selectPostulant" :curriculum="selectPostulant" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="fill-height d-flex" style="overflow: hidden">
      <v-navigation-drawer
        v-model="openFilters"
        :permanent="windowSize.x > 1156"
        max-width="330"
        :absolute="windowSize.x <= 1156"
        min-width="330"
        width="330"
        touchless
        disable-resize-watcher
        style="min-width: 330px"
      >
        <div class="px-6 pt-6">
          <p class="display-1 font-weight-bold grey--text">Filtros</p>
        </div>
        <v-expansion-panels
          class="my-3"
          style="padding-right: 1px"
          accordion
          flat
          tile
          multiple
          :disabled="loading"
        >
          <v-expansion-panel v-for="(filter, index) of filters" :key="index">
            <v-expansion-panel-header class="font-weight-bold">{{ filter.nombre }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list-item
                v-if="filter.id === 'palabra_clave'"
                style="min-height: auto"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title>
                    <v-text-field
                      v-model="selectFilters.palabras_clave"
                      label="Puesto, estudio o palabra clave"
                      filled
                      rounded
                      dense
                      prepend-inner-icon="mdi-magnify"
                      hide-details
                      @keyup="searchDebounce"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else-if="filter.id === 'edad'" style="min-height: auto" class="px-0">
                <v-list-item-content class="py-1">
                  <v-list-item-title class="d-flex">
                    <v-text-field
                      v-model="selectFilters.informacion_personal.edad.desde"
                      label="Desde"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mr-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-text-field
                      v-model="selectFilters.informacion_personal.edad.hasta"
                      label="Hasta"
                      filled
                      rounded
                      dense
                      hide-details
                      class="ml-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="filter.id === 'lugar_residencia'"
                style="min-height: auto"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title>
                    <v-select
                      v-model="selectFilters.informacion_contacto.pais"
                      label="País"
                      filled
                      rounded
                      :items="countries"
                      item-text="name"
                      menu-props="auto"
                      clearable
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                      @click:clear="searchDebounce(); selectFilters.informacion_contacto.provincia = ''; selectFilters.informacion_contacto.ciudad = ''"
                      @change="searchDebounce(); selectFilters.informacion_contacto.provincia = ''; selectFilters.informacion_contacto.ciudad = ''; retriveProvincias(selectFilters.informacion_contacto.pais);"
                    ></v-select>
                    <v-select
                      v-model="selectFilters.informacion_contacto.provincia"
                      label="Provincia"
                      filled
                      rounded
                      :items="provinces"
                      item-text="name"
                      menu-props="auto"
                      dense
                      hide-details
                      clearable
                      class="mb-2"
                      @click:clear="searchDebounce(); selectFilters.informacion_contacto.ciudad = ''"
                      @change="searchDebounce(); selectFilters.informacion_contacto.ciudad = ''; retriveCities(selectFilters.informacion_contacto.pais, selectFilters.informacion_contacto.provincia);"
                    ></v-select>
                    <v-select
                      v-model="selectFilters.informacion_contacto.ciudad"
                      label="Ciudad"
                      filled
                      rounded
                      :items="cities"
                      item-text="name"
                      menu-props="auto"
                      clearable
                      dense
                      @click:clear="searchDebounce();"
                      hide-details
                      @change="searchDebounce"
                    ></v-select>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="filter.id === 'experiencia_laboral'"
                style="min-height: auto"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title>
                    <v-text-field
                      v-model="selectFilters.experiencia_laboral.puesto"
                      label="Puesto"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-text-field
                      v-model="selectFilters.experiencia_laboral.nombre_empresa"
                      label="Empresa"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-select
                      v-model="selectFilters.experiencia_laboral.area_puesto"
                      label="Nombre del área"
                      filled
                      rounded
                      :items="areas"
                      menu-props="auto"
                      dense
                      hide-details
                      class="mb-2"
                      clearable
                      @click:clear="searchDebounce"
                      @change="searchDebounce"
                    ></v-select>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="filter.id === 'pretension_salarial'"
                style="min-height: auto"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title class="d-flex">
                    <v-text-field
                      v-model="selectFilters.preferencia_salarial.desde"
                      label="Desde"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mr-2"
                      prefix="$"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-text-field
                      v-model="selectFilters.preferencia_salarial.hasta"
                      label="Hasta"
                      filled
                      rounded
                      dense
                      hide-details
                      class="ml-2"
                      prefix="$"
                      @keyup="searchDebounce"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="filter.id === 'educacion'"
                style="min-height: auto"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title>
                    <v-text-field
                      v-model="selectFilters.educacion.institucion"
                      label="Institución educativa"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-text-field
                      v-model="selectFilters.educacion.titulo"
                      label="Título obtenido o a obtener"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-select
                      v-model="selectFilters.educacion.tipo_estudio"
                      label="Nivel"
                      filled
                      rounded
                      menu-props="auto"
                      :items="niveles"
                      dense
                      clearable
                      @click:clear="searchDebounce"
                      hide-details
                      class="mb-2"
                      @change="searchDebounce"
                    ></v-select>
                    <v-select
                      v-model="selectFilters.educacion.estado"
                      label="Estado"
                      filled
                      rounded
                      menu-props="auto"
                      :items="estados"
                      dense
                      @click:clear="searchDebounce"
                      clearable
                      hide-details
                      class="mb-2"
                      @change="searchDebounce"
                    ></v-select>
                    <v-radio-group
                      @change="searchDebounce"
                      v-model="selectFilters.educacion.tipo_estudio_filtro"
                      hide-details
                      class="mt-0 mb-2"
                    >
                      <v-radio
                        label="Nivel exacto"
                        color="primary"
                        value="nivel exacto"
                        on-icon="mdi-checkbox-blank-circle"
                      ></v-radio>
                      <v-radio
                        label="Nivel mínimo"
                        color="primary"
                        value="nivel minimo"
                        on-icon="mdi-checkbox-blank-circle"
                      ></v-radio>
                    </v-radio-group>
                    <v-text-field
                      v-model="selectFilters.educacion.area"
                      label="Nombre del área"
                      filled
                      rounded
                      :items="areasEstudio"
                      menu-props="auto"
                      dense
                      hide-details
                      class="mb-2"
                      clearable
                      @click:clear="searchDebounce"
                      @change="searchDebounce"
                    ></v-text-field>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="filter.id === 'idiomas'"
                style="min-height: auto"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <div>
                    <v-list-item-title>
                      <v-select
                        v-model="selectFilters.idiomas.idioma"
                        :items="languagesOption"
                        label="Idioma"
                        menu-props="auto"
                        filled
                        rounded
                        clearable
                        @click.clear="searchDebounce"
                        dense
                        hide-details
                        class="mb-2"
                        @change="searchDebounce"
                      ></v-select>
                      <v-select
                        v-model="selectFilters.idiomas.nivel_oral"
                        :items="levelOptions"
                        label="Nivel oral"
                        menu-props="auto"
                        filled
                        rounded
                        dense
                        hide-details
                        class="mb-2"
                        clearable
                        @click.clear="searchDebounce"
                        @change="searchDebounce"
                      ></v-select>
                      <v-select
                        v-model="selectFilters.idiomas.nivel_escrito"
                        :items="levelOptions"
                        label="Nivel escrito"
                        menu-props="auto"
                        filled
                        rounded
                        dense
                        hide-details
                        class="mb-2"
                        clearable
                        @click.clear="searchDebounce"
                        @change="searchDebounce"
                      ></v-select>
                    </v-list-item-title>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else-if="filter.id === 'genero'" style="min-height: auto" class="px-0">
                <v-list-item-content class="py-1">
                  <v-list-item-title>
                    <v-radio-group
                      @change="searchDebounce"
                      v-model="selectFilters.informacion_personal.genero"
                      hide-details
                      class="mt-0"
                    >
                      <v-radio
                        label="Indistinto"
                        color="primary"
                        value="indistinto"
                        on-icon="mdi-checkbox-blank-circle"
                      ></v-radio>
                      <v-radio
                        label="Masculino"
                        color="primary"
                        value="Masculino"
                        on-icon="mdi-checkbox-blank-circle"
                      ></v-radio>
                      <v-radio
                        label="Femenino"
                        color="primary"
                        value="Femenino"
                        on-icon="mdi-checkbox-blank-circle"
                      ></v-radio>
                      <v-radio
                        label="Otro"
                        color="primary"
                        value="Otros"
                        on-icon="mdi-checkbox-blank-circle"
                      ></v-radio>
                    </v-radio-group>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="filter.id === 'datos_personales'"
                style="min-height: auto"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title>
                    <v-text-field
                      v-model="selectFilters.informacion_personal.nombres"
                      label="Nombre"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-text-field
                      v-model="selectFilters.informacion_personal.apellidos"
                      label="Apellido"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-text-field
                      v-model="selectFilters.informacion_personal.numero_documento"
                      label="CI"
                      filled
                      rounded
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-text-field>
                    <v-select
                      v-model="selectFilters.informacion_personal.nacionalidad"
                      label="Nacionalidad"
                      filled
                      item-text="name"
                      rounded
                      menu-props="auto"
                      clearable
                      @click:clear="searchDebounce"
                      :items="countries"
                      dense
                      hide-details
                      class="mb-2"
                      @keyup="searchDebounce"
                    ></v-select>
                    <v-switch
                      v-model="selectFilters.informacion_personal.tiene_foto"
                      @change="searchDebounce"
                      dense
                      hide-details
                      class="ml-1"
                      inset
                    >
                      <template v-slot:label>Ver solo HV con foto</template>
                    </v-switch>
                    <v-switch
                      v-model="selectFilters.informacion_personal.tiene_discapacidad"
                      @change="searchDebounce"
                      dense
                      hide-details
                      class="ml-1"
                      inset
                      style="white-space: break-spaces;"
                      label
                    >
                      <template v-slot:label>Ver solo candidatos con discapacidad</template>
                    </v-switch>
                    <v-switch
                      v-model="selectFilters.informacion_personal.tiene_movilidad"
                      @change="searchDebounce"
                      dense
                      hide-details
                      class="ml-1"
                      inset
                      style="white-space: break-spaces;"
                    >
                      <template v-slot:label>Ver solo candidatos con movilidad propia</template>
                    </v-switch>
                    <v-switch
                      v-model="selectFilters.informacion_personal.tiene_licencia"
                      @change="searchDebounce"
                      dense
                      hide-details
                      class="ml-1"
                      inset
                      style="white-space: break-spaces;"
                    >
                      <template v-slot:label>Ver solo candidatos con licencia de conducir</template>
                    </v-switch>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-navigation-drawer>
      <v-container v-if="loading" class="fill-height pa-0 align-start" fluid>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-container>
      <v-container v-else style="overflow: auto" fluid class="accent">
        <v-row>
          <v-col class="ml-2">
            <p class="display-1 font-weight-bold mb-0">Buscar postulantes</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0 d-flex pl-5 pr-9">
            <v-btn v-if="windowSize.x <= 1156" text @click="openFilters = true">
              <v-icon class="mr-2">mdi-filter</v-icon>Filtros
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <CardPortulant
              v-for="postulante in postulants"
              :key="postulante._id"
              :postulant="postulante"
              class="mb-2"
              @click="
                selectPostulant = postulante;
                dialogShowCurriculum = true;"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { debounce } from "debounce";

import CardPortulant from "@/components/CardPostulant.vue";
import Curriculum from "@/components/Curriculum";

import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";
import { mapActions, mapState } from "vuex";

import store from "@/store";
import areasSubareas from "@/assets/data/areas-subareas.js";
import areasEstudio from "@/assets/data/areas-estudio.js";

export default {
  name: "CompanySearchPostulants",
  components: {
    CardPortulant,
    Curriculum
  },
  mixins: [validationMixin, windowSizeMixin],
  validations: {},
  data() {
    return {
      loading: false,
      dialogShowCurriculum: false,
      openFilters: false,
      areasEstudio,
      languagesOption: [
        "Ingles",
        "Español",
        "Coreano",
        "Japones",
        "Francés",
        "Italiano",
        "Holandés"
      ],
      levelOptions: ["Básico", "Intermedio", "Avanzado", "Nativo"],
      filters: [
        {
          id: "palabra_clave",
          nombre: "Palabra clave"
        },
        {
          id: "edad",
          nombre: "Edad"
        },
        {
          id: "lugar_residencia",
          nombre: "Lugar de Residencia"
        },
        {
          id: "experiencia_laboral",
          nombre: "Experiencia Laboral"
        },
        {
          id: "pretension_salarial",
          nombre: "Pretensión salarial"
        },
        {
          id: "educacion",
          nombre: "Educación"
        },
        {
          id: "idiomas",
          nombre: "Idioma"
        },
        {
          id: "genero",
          nombre: "Género"
        },
        {
          id: "datos_personales",
          nombre: "Datos Personales"
        }
      ],
      selectFilters: {
        palabras_clave: undefined,
        informacion_personal: {
          edad: {
            desde: undefined,
            hasta: undefined
          },
          genero: "indistinto",
          nombres: undefined,
          apellidos: undefined,
          numero_documento: undefined,
          nacionalidad: undefined,
          tiene_foto: undefined,
          tiene_discapacidad: undefined,
          tiene_licencia: undefined,
          tiene_movilidad: undefined
        },
        informacion_contacto: {
          pais: undefined,
          provincia: undefined,
          ciudad: undefined
        },
        experiencia_laboral: {
          puesto: undefined,
          nombre_empresa: undefined,
          area_puesto: undefined
        },
        preferencia_salarial: {
          desde: undefined,
          hasta: undefined
        },
        educacion: {
          institucion: undefined,
          titulo: undefined,
          tipo_estudio: undefined,
          tipo_estudio_filtro: "nivel minimo",
          estado: undefined
        },
        idiomas: {
          idioma: undefined,
          nivel_oral: undefined,
          nivel_escrito: undefined
        }
      },
      countries: [],
      provinces: [],
      cities: [],
      postulants: [],
      selectPostulant: undefined,
      areas: Object.keys(areasSubareas),
      niveles: [
        "Secundario",
        "Terciario",
        "Universitario",
        "Posgrado",
        "Master",
        "Doctorado",
        "Otro"
      ],

      estados: ["En Curso", "Graduado", "Abandonado"]
    };
  },
  computed: {},
  created() {
    this.retrieveCountries();
    this.getPostulants();
  },
  methods: {
    getFormatDate(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    getPostulants() {
      this.loading = true;
      store
        .dispatch("companies/postulants/retrievePostulants", this.selectFilters)
        .then(postulants => {
          this.postulants = postulants.map(postulant => ({
            ...postulant,
            experienciaLaboralesIndex: 0,
            educacionIndex: 0
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchDebounce: debounce(function() {
      this.getPostulants();
    }, 600),
    retrieveCountries() {
      this.$store
        .dispatch("retriveCountries")
        .then(data => {
          this.countries = data;
          if (this.selectFilters.informacion_contacto.pais)
            this.retriveProvincias(
              this.selectFilters.informacion_contacto.pais
            );
        })
        .catch(err => {
          // console.log(err.response);
        })
        .finally(() => {});
    },
    retriveProvincias(countryName) {
      const country = this.countries.find(
        country => country.name === countryName
      );

      this.$store
        .dispatch("retriveProvincias", country.id)
        .then(data => {
          this.provinces = data;
          if (this.selectFilters.informacion_contacto.provincia)
            this.retriveCities(
              this.selectFilters.informacion_contacto.pais,
              this.selectFilters.informacion_contacto.provincia
            );
        })
        .catch(err => {
          // console.log(err.response);
        })
        .finally(() => {});
    },
    retriveCities(countryName, provinceName) {
      const country = this.countries.find(
        country => country.name === countryName
      );
      const province = this.provinces.find(
        province => province.name === provinceName
      );

      this.$store
        .dispatch("retriveCities", {
          country: country.id,
          province: province.id
        })
        .then(data => {
          this.cities = data;
        })
        .catch(err => {
          // console.log(err.response);
        })
        .finally(() => {});
    }
  }
};
</script>

<style>
</style>